import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ErrorHandlerService } from '@manager-app/service/error-handler.service';
import { DictionaryEntryModel, HxCurrencyPipe, HxStorageInvoiceService, HxUiLabelPipe, StorageInvoiceModel, StorageInvoiceRequest } from 'hx-services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageInvoicesConfirmComponent } from '@manager-app/storage/storage-invoices-confirm/storage-invoices-confirm.component';
import { addMinutes } from 'date-fns';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { HxDateSelectComponent } from 'hx-component';
import { SpendCategorySearchComponent } from '../spend/spend-category-search/spend-category-search.component';


@Component({
    selector: 'app-storage-received.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './storage-invoices-receive.component.html',
    styleUrls: ['./storage-invoices-receive.component.css'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, RouterLink, NgIf, FormsModule, ReactiveFormsModule, HxDateSelectComponent, NgFor, SpendCategorySearchComponent, TranslocoPipe, HxCurrencyPipe, HxUiLabelPipe]
})
export class StorageInvoicesReceiveComponent implements OnInit, OnDestroy {
  invoiceFormKeys = {
    incomingInvoiceNumber: 'incomingInvoiceNumber',
    incomingInvoiceDate: 'incomingInvoiceDate',
    paymentType: 'paymentType',
    spendCategory: 'spendCategory',
    supplier: 'supplier',
    products: 'products'
  };
  id: number;
  isLoading = {
    invoice: false,
    submit: false,
  };
  invoice: StorageInvoiceModel;
  invoiceForm: UntypedFormGroup;
  items: UntypedFormArray;
  types = ['CASH', 'POS'];
  private sub: Subscription;

  constructor(
    private aRoute: ActivatedRoute,
    private storageInvoiceService: HxStorageInvoiceService,
    private router: Router,
    private toastr: HcToastrService,
    private fb: UntypedFormBuilder,
    private errorService: ErrorHandlerService,
    public modal: NgbModal,
    private tr: TranslocoService
  ) { }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.createForm();
    this.sub = this.aRoute.params.subscribe(params => {
      this.id = params['id'] || null;
      this.loadData();
    });
  }

  setFormValue(key, value) {
    this.invoiceForm.controls[key].patchValue(value);
  }

  selectSpendCategory(category?: DictionaryEntryModel) {
    if (category) {
      this.setFormValue(this.invoiceFormKeys.spendCategory, category);
    }
  }

  onSubmitForm() {
    this.isLoading.submit = true;
    const obj: StorageInvoiceRequest = this.invoiceForm.getRawValue();
    obj.products = this.invoice.products;

    this.storageInvoiceService.receiveInvoice(this.id, obj).subscribe(() => {
      this.toastr.success(this.tr.translate('storage-invoices-receive.ts.invoiceSuccess'));
      this.isLoading.submit = false;
      this.router.navigate(['/storage/invoices'], {relativeTo: this.aRoute});
    }, err => {
      this.isLoading.submit = false;
      this.errorService.handler(err.error);
    });
  }

  showRejectModal(storageInvoiceId: number): void {
    const modal = this.modal.open(StorageInvoicesConfirmComponent, { size: 'lg' });
    modal.componentInstance.storageInvoiceId = storageInvoiceId;
    modal.result
      .then(() => {
      })
      .catch(() => {
      });
  }

  hasPermission(status: string, receivedDate: string): boolean {
    const d = addMinutes(new Date(receivedDate), 20);
    if (status === 'RECEIVED' && d > new Date()) {
      return true;
    } else {
      return status === 'SENT';
    }
  }

  private createForm(): void {
    this.invoiceForm = this.fb.group({
      incomingInvoiceNumber: [''],
      incomingInvoiceDate: [null],
      paymentType: ['POS'],
      spendCategory: [null],
      supplier: [''],
      products: this.fb.array([]),
    });
  }

  private loadData() {
    if (this.id) {
      this.invoice = null;
      this.isLoading.invoice = true;

      this.storageInvoiceService.getStorageInvoiceById(this.id).subscribe(result => {
        this.invoice = result;
        this.setFormValue(this.invoiceFormKeys.incomingInvoiceNumber, this.invoice.incomingInvoiceNumber);
        this.setFormValue(this.invoiceFormKeys.supplier, this.invoice.supplier.id);
        this.isLoading.invoice = false;
      });
    }
  }
}
